import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Search, Plus } from "lucide-react";
import { Input } from "@/shared/components/ui/input";
import { Button } from "@/shared/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { useTenantListStore } from "@/store";
import { TENANT_STATUS_FILTER_OPTIONS } from "../constants/tenantStatus";
import { TENANTS_LISTING_CONFIG } from "../constants/listingConfig";

const ALL_VALUE = "__all__";

export function TenantsHeader() {
  const { t } = useTranslation("tenants");
  const navigate = useNavigate();
  const searchQuery = useTenantListStore((s) => s.searchQuery);
  const setSearchQuery = useTenantListStore((s) => s.setSearchQuery);
  const status = useTenantListStore((s) => s.status);
  const setStatus = useTenantListStore((s) => s.setStatus);

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="relative w-[320px]">
          <Input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            aria-label={t("list.searchLabel")}
            placeholder={t("list.searchPlaceholder")}
            className="w-full pr-10 pl-3 text-sm"
          />
          <Search
            className="pointer-events-none absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground"
            aria-hidden
          />
        </div>

        <Select
          value={status || ALL_VALUE}
          onValueChange={(next) => setStatus(next === ALL_VALUE ? "" : next)}
        >
          <SelectTrigger
            className="h-9 w-[180px]"
            aria-label={t("list.filter.status")}
          >
            <SelectValue placeholder={t("list.filter.status")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL_VALUE}>
              {t("list.filter.allStatuses")}
            </SelectItem>
            {TENANT_STATUS_FILTER_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {t(`status.${opt.value}`, { defaultValue: opt.label })}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={() => navigate(`${TENANTS_LISTING_CONFIG.basePath}/add`)}
        className="h-9 border-primary bg-background px-4 text-primary hover:bg-accent hover:text-accent-foreground"
      >
        <Plus className="h-4 w-4" aria-hidden />
        <span>{t("list.add")}</span>
      </Button>
    </div>
  );
}
